module.exports = __webpack_public_path__ + "img/icon-hero-rating-appstore.981478b.svg";